module.exports = __webpack_public_path__ + "static/media/trash.457a62be.svg";